import roundaboutTextured from '../../assets/examples/roundabout-textured.png';
import roundabout from '../../assets/examples/roundabout.png';
import valsaline from '../../assets/examples/valsaline.png';
import veruda from '../../assets/examples/veruda.png';
import zadar from '../../assets/examples/zadar.png';
import { EXAMPLE_MODELS } from '../setup-project/constants/modelConstants';

const PREVIEWS: Record<string, string> = {
  'roundabout.glb': roundabout,
  'roundabout-textured.glb': roundaboutTextured,
  'veruda.glb': veruda,
  'zadar.obj': zadar,
  'valsaline.obj': valsaline,
};

export type ExampleModel = (typeof EXAMPLE_MODELS)[number] & { preview?: string };

/** The example models with a small picture of each. */
export const EXAMPLES: ExampleModel[] = EXAMPLE_MODELS.map((model) => ({
  ...model,
  preview: PREVIEWS[model.filename],
}));

export async function fetchExampleModel(example: ExampleModel): Promise<File> {
  const response = await fetch(example.url);
  if (!response.ok) throw new Error(`Loading the example ${example.filename} failed: ${response.status}`);
  return new File([await response.blob()], example.filename);
}
